export function checkSubscription() {
  let subscriptionData = localStorage.getItem('subscription')
  if (subscriptionData) {
    const parsed = JSON.parse(subscriptionData);
    let buffer;
    if (parsed.canceled) {
      buffer = 0;
    } else {
      buffer = 2;
    }
    const today = new Date();
    let dateWithBufer = Number(
      new Date().setDate(today.getDate() - buffer)
    );
    if (dateWithBufer < Number(parsed.subscription_end_date)) {
      return true;
    } else
      return false;
  } else {
    return false;
  }
}